import { TypedElement } from "../TypedElement";
import { ITiroElement } from "./types";

export const TiroElement = {
  ...TypedElement,
  isTiroElement: (o: unknown): o is ITiroElement => {
    return typeof o === "object" && TiroElement.isElement(o);
  },
};
